import {
  singleButtonWrapperStyles,
} from 'components/Templates/commonStyles/DefaultCssValues';

/* eslint-disable */
export default {
  buttonHeroPrimaryTop: {
    '0': {
      ...singleButtonWrapperStyles,
      'width': 'fit-content',
      'display': 'inline-block',
      'height': 'auto',
      'color': '{primaryColor}',
      'font-size': '14px',
      'border-top-left-radius': '3rem',
      'border-top-right-radius': '3rem',
      'border-bottom-left-radius': '3rem',
      'border-bottom-right-radius': '3rem',
      'border-top-style': 'solid',
      'border-bottom-style': 'solid',
      'border-left-style': 'solid',
      'border-right-style': 'solid',
      'border-top-width': `1px`,      
      'border-bottom-width': `1px`,      
      'border-left-width': `1px`,
      'border-right-width': `1px`,
      'background-color': '{buttonColor}',
      'padding-top': '1rem',
      'padding-bottom': '1rem',
      'padding-left': '1rem',
      'padding-right': '1rem',
      'margin-right': '1rem'
    },
    '76_8' : {
      'margin-bottom': '1rem'
    },
    '37_5': {
      'font-size': '12px',
      'width': '100%'
    }
  }
};
